/** Which conversation panel is shown in the right-hand chat drawer. */
export const CHAT_DRAWER_PANEL = {
  MAIN: 'main',
  GROUPS: 'groups'
}
